import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Section from './Section';
import CoreQuestion from './CoreQuestion';
import PickableQuestion from './PickableQuestion';

export default class extends Component {
  static propTypes = {
    section: PropTypes.object.isRequired,
    questions: PropTypes.array.isRequired,
    onToggleSelect: PropTypes.func.isRequired,
    onToggleRequire: PropTypes.func.isRequired,
    pickedQuestions: PropTypes.object.isRequired,
  }

  renderQuestions() {
    if (this.props.questions.length > 0) {
      return this.props.questions.map(this.renderQuestion.bind(this));
    }
    return (<tr><td colSpan="5">No questions to pick from.</td></tr>);
  }

  renderQuestion(question) {
    const questionPickInfo = this.props.pickedQuestions[question.field];
    const isPicked = (questionPickInfo !== undefined);
    const isRequired = (isPicked ? questionPickInfo.required : false);
    const key = `question-${question.field}`;
    let questionEl;

    if (question.core) {
      questionEl = <CoreQuestion question={question} key={key} />;
    } else {
      questionEl = (
        <PickableQuestion
          question={question}
          required={isRequired}
          picked={isPicked}
          onToggleSelect={this.props.onToggleSelect.bind(this, question)}
          onToggleRequire={this.props.onToggleRequire.bind(this, question)}
          key={key}
        />
      );
    }

    return questionEl;
  }

  renderTable() {
    const questions = this.renderQuestions();

    return (
      <table className="u-w-full StaffTable StaffTable--largeText u-mt-4">
        <thead>
          <tr>
            <th>Include?</th>
            <th>Field</th>
            <th>Question</th>
            <th>Type</th>
            <th>Required?</th>
          </tr>
        </thead>
        <tbody>
          {questions}
        </tbody>
        <tfoot>
          <tr>
            <td colSpan="5">
              <span className="hint">
                Your changes will only be saved when you submit the form.
              </span>
            </td>
          </tr>
        </tfoot>
      </table>
    );
  }

  render() {
    return (
      <Section
        title={this.props.section.title}
        previewButtonProps={{
          previewPath: this.props.section.previewPath,
          previewData: this.props.pickedQuestions,
          target: this.props.section.slug,
        }}>
        {this.renderTable()}
      </Section>
    );
  }
}
